import {
  doc,
  getDoc,
  getDocs,
  writeBatch,
  collection,
} from 'firebase/firestore';

/**
 * Moves a gauger certificate document and its history subcollection to the archive location
 * @param {Firestore} db - The Firestore instance
 * @param {string} sourcePath - The path to the source document
 * @param {string} destinationPath - The path to the destination document
 * @returns {Promise<void>}
 */
const moveGaugerCertificate = async (db, sourcePath, destinationPath) => {
  try {
    // Create references to source and destination documents
    const sourceRef = doc(db, sourcePath);
    const destinationRef = doc(db, destinationPath);

    // Get the source document data
    const sourceDoc = await getDoc(sourceRef);
    if (!sourceDoc.exists()) {
      throw new Error(`Source document not found: ${sourcePath}`);
    }

    // Start a batch write
    const batch = writeBatch(db);

    // Copy the main document
    batch.set(destinationRef, sourceDoc.data());

    // Process the history subcollection
    const historySourceCollectionRef = collection(sourceRef, 'history');
    const historyDestinationCollectionRef = collection(destinationRef, 'history');

    // Get all documents in the history subcollection
    const querySnapshot = await getDocs(historySourceCollectionRef);

    // Copy each document in the history subcollection
    querySnapshot.forEach((document) => {
      batch.set(doc(historyDestinationCollectionRef, document.id), document.data());
    });

    // Delete the original document
    batch.delete(sourceRef);

    // Commit the batch
    await batch.commit();
  } catch (error) {
    console.error('Error moving gauger certificate:', error);
    throw error;
  }
};

export default moveGaugerCertificate;
